import React from 'react'
import './home.css'
import {FaAngleDoubleDown} from 'react-icons/fa'
import mainImage from '../../assets/mainImage-removebg-preview.png'
// import sideimg1 from  '../../assets/img1.webp'

export default function Landing(){
  return (
    <div>
        {/* <!-- Start Landing --> */}
        <div class="landing">
        <div class="container">
        {/* <img  src={sideimg1} alt="" /> */}
            <div class="text">
            <h1 style={{textAlign:"center"}}>नमस्ते 🙏</h1>
            {/* <p style={{color:'black', textAlign:'center'}}>The Astronomy and Mathematics Society of NSUT is a place where dreams are realized,  */}

            <p style={{color:'white', textAlign:'center'}}>The Astronomy and Mathematics Society of NSUT is a place where dreams are realized, 
              understood and glorified. The amalgamation of sky-gazing and 
              mathematical ideas brings us all together, working to promote these 
              concepts amongst our peers.</p>
            </div>
            <div class="image">
            <img style={{width:'450px'}} src={mainImage} alt="" />
            </div>
        </div>
        <a href="#about" class="go-down">
            {/* <i class="fas fa-angle-double-down fa-2x"></i> */}
            <FaAngleDoubleDown className='i'/>
        </a>
        </div>
        {/* <!-- End Landing --> */}
    </div>
  )
}
